import React, { useEffect, useState, useMemo } from 'react';

import { Row, Form, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

import { Button } from '../../../components';
import { generateReport, getReportData, removeReportData, getList } from '../operations';
import { customStyles } from '../utils';

import './styles.scoped.css';

const WebPortalActivityForm = ({ setForm, form, setLoadingResults, setData, setShowResults }) => {
  const navigate = useNavigate();

  const [branches, setBranches] = useState([]);
  const [isLoadingBranches, setIsLoadingBranches] = useState(false);

  useEffect(() => {
    handleGetBranches();
  }, []);

  const handleGetBranches = async () => {
    setIsLoadingBranches(true);
    const newBranches = await getList('clients/branches');
    setBranches(newBranches);
    setIsLoadingBranches(false);
  };

  const branchOptions = useMemo(
    () =>
      branches?.map(({ Branch_Code }) => ({
        label: Branch_Code,
        value: Branch_Code,
      })),
    [branches],
  );

  const handleViewResults = async () => {
    setLoadingResults(true);
    const { PerEnddate, Branch } = form;
    try {
      const response = await generateReport({
        endpoint: 'web-portal-activity-report',
        payload: {
          PerEnddate,
          Branch,
        },
      });
      console.log({ response });
      if (response?.statusCode === 200 && response?.location) {
        const data = await getReportData(response.location);
        await removeReportData(response.location);
        if (data?.length) {
          setData(data);
          setShowResults(true);
        } else {
          alert('No data found matching your criteria.');
        }
      } else {
        alert(response?.statusDescription || 'No data found matching your criteria.');
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingResults(false);
    }
  };

  const handleChange = e => {
    const _form = { ...form, [e.target.name]: e.target.value };
    setForm(_form);
  };
  
  return (
    <Form
      noValidate
      onSubmit={() => {}}
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}>
      <div className="filters-row">
        <div
          className="filter-row"
          style={{
            marginTop: '30px',
          }}>
          <Form.Group as={Row} controlId="PerEnddate" style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>Period End Date</Form.Label>
            <Form.Control
              style={{
                width: '150px',
                height: '30px',
                marginRight: '20px',
              }}
              as="input"
              type="date"
              name="PerEnddate"
              value={form?.PerEnddate}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </div>

        <div className="filter-row">
          <Form.Group as={Row} controlId="Branch" style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '290px' }}>Branch Number</Form.Label>
            <div className="dropdown-spinner-container">
              <Select
                isMulti
                closeMenuOnSelect={false}
                isClearable
                styles={customStyles('360px')}
                options={branchOptions}
                value={form?.Branch
                  ? form.Branch.split(',')
                      .map(code => branchOptions.find(option => String(option.value) === code))
                      .filter(Boolean)
                  : []}
                onChange={selectedOptions => {
                  const selectedCodes = selectedOptions.map(option => option.value);
                  setForm({
                    ...form,
                    Branch: selectedCodes.join(','),
                  });
                }}
              />
              <Spinner
                as="span"
                animation="border"
                size="sm"
                aria-hidden="true"
                className="dropdown-spinner"
                hidden={!isLoadingBranches}
              />
            </div>
          </Form.Group>
        </div>
      </div>
      <div className="buttons-row">
        <Button variant="primary" onPress={() => handleViewResults()} style={{ marginRight: '20px', width: '100px' }} text="View" />

        <Button
          style={{ width: '100px' }}
          onPress={() => navigate('/edge-reporting')}
          variant="outline"
          text="Cancel"
        />
      </div>
    </Form>
  );
};

export default WebPortalActivityForm;
